<template>
  <div class="box">
    <div class="h_title">平台动态</div>

    <div class="scroll-container">
      <ul class="scroll-content">
        <!-- 复制一份相同内容实现无缝衔接 -->
        <li v-for="item in list" :key="'a'+item.trendId" class="item">
          <div class="left">
            <a>{{ item.empName }}</a> 进行了 <a>“{{ item.content }}”</a>
          </div>
          <div class="right">{{ renderTime(item.createdAt) }}</div>
        </li>
        <li v-for="item in list" :key="'b'+item.trendId" class="item">
          <div class="left">
            <a>{{ item.empName }}</a> 进行了 <a>“{{ item.content }}”</a>
          </div>
          <div class="right">{{ renderTime(item.createdAt) }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import 'dayjs/locale/zh-cn'

export default {
  data() {
    return{

    }
  },
  created() {
    this.getList({size:99});
  },
  computed: {
    ...mapState("trendList", ["list"]),
  },
  methods: {
    ...mapActions("trendList", ["getList"]),
    renderTime(time) {
      dayjs.locale('zh-cn')
      dayjs.extend(relativeTime);
      const timestamp = time * 1000; // 转换为毫秒
      const fromNow = dayjs(timestamp).fromNow();
      return fromNow;
    },
  },
};
</script>

<style scoped lang="scss">
@use '../homeStyle.scss' as *;
.box {
  width: 100%;
  height: 251px;
  border-radius: $border-radius;
  background: $bg-j-1;

}
</style>
